<section class="playground">
  <h2 class="playground__heading">Text field</h2>

  <p class="playground__hint playground__doc-ref">
    Documentación canónica (cuándo usarlo, contrato de inputs/outputs, Figma):
    <code>docs/CATALOGO-UI.md</code> — sección <strong>3. Text field</strong>.
  </p>

  <div class="playground__section playground__section--modal">
    <h3 class="playground__section-title">Patrón formulario (como user-modal)</h3>
    <p class="playground__section-hint">
      El <code>FormControl</code> se pasa como <code>[control]</code>. Los errores se resuelven automáticamente o
      se personalizan con <code>[errorMessages]</code>. El formulario completo vive en el componente padre.
    </p>
    <div class="playground__preview-box playground__preview-box--modal">
      <app-text-field
        appearance="outlined"
        widthLayout="fill"
        label="Nombre completo"
        placeholder="Nombre y apellido"
        [control]="fullNameControl"
        [errorMessages]="{ required: 'El nombre es obligatorio' }"
      ></app-text-field>
      <button type="button" class="playground__btn" (click)="markFullNameTouched()">Marcar touched (error)</button>
    </div>
  </div>

  <div class="playground__grid">
    <div class="playground__controls">
      <label class="playground__field">
        <span>appearance</span>
        <select [(ngModel)]="appearance">
          <option *ngFor="let a of appearances" [ngValue]="a">{{ a }}</option>
        </select>
      </label>
      <label class="playground__field">
        <span>size</span>
        <select [(ngModel)]="size">
          <option *ngFor="let s of sizes" [ngValue]="s">{{ s }}</option>
        </select>
      </label>
      <label class="playground__field">
        <span>widthLayout</span>
        <select [(ngModel)]="widthLayout">
          <option *ngFor="let w of widthLayouts" [ngValue]="w">{{ w }}</option>
        </select>
      </label>
      <label class="playground__field" *ngIf="widthLayout === 'ds'">
        <span>maxWidth (opcional)</span>
        <input type="text" [(ngModel)]="maxWidthCustom" placeholder="Ej. 400px o vacío = 292px" />
      </label>
      <label class="playground__field">
        <span>label</span>
        <input type="text" [(ngModel)]="label" />
      </label>
      <label class="playground__field">
        <span>placeholder</span>
        <input type="text" [(ngModel)]="placeholder" />
      </label>
      <label class="playground__field">
        <span>hint</span>
        <input type="text" [(ngModel)]="hint" />
      </label>
      <label class="playground__field">
        <span>iconLeading</span>
        <select [(ngModel)]="iconLeading">
          <option *ngFor="let i of iconExamples" [ngValue]="i">{{ i || '(ninguno)' }}</option>
        </select>
      </label>
      <label class="playground__field">
        <span>iconTrailing</span>
        <select [(ngModel)]="iconTrailing">
          <option *ngFor="let i of iconExamples" [ngValue]="i">{{ i || '(ninguno)' }}</option>
        </select>
      </label>
      <label class="playground__field">
        <span>prefixText</span>
        <input type="text" [(ngModel)]="prefixText" placeholder="Ej. https://" />
      </label>
      <label class="playground__field playground__field--checkbox">
        <input type="checkbox" [(ngModel)]="hasCharacterCounter" />
        <span>hasCharacterCounter</span>
      </label>
      <label class="playground__field" *ngIf="hasCharacterCounter">
        <span>maxLength</span>
        <input type="number" [(ngModel)]="maxLength" min="1" />
      </label>
      <label class="playground__field playground__field--checkbox">
        <input type="checkbox" [(ngModel)]="disabled" />
        <span>disabled</span>
      </label>
      <label class="playground__field playground__field--checkbox">
        <input type="checkbox" [(ngModel)]="successful" />
        <span>successful</span>
      </label>
    </div>

    <div class="playground__preview">
      <p class="playground__preview-title">Vista previa (control vacío: label en reposo hasta escribir o enfocar)</p>
      <div class="playground__preview-box">
        <app-text-field
          [control]="demoControl"
          [appearance]="appearance"
          [size]="size"
          [widthLayout]="widthLayout"
          [maxWidth]="widthLayout === 'ds' && maxWidthCustom.trim() ? maxWidthCustom.trim() : undefined"
          [label]="label"
          [placeholder]="placeholder"
          [hint]="hint"
          [iconLeading]="iconLeading || undefined"
          [iconTrailing]="iconTrailing || undefined"
          [prefixText]="prefixText || undefined"
          [hasCharacterCounter]="hasCharacterCounter"
          [maxLength]="hasCharacterCounter ? maxLength : undefined"
          [disabled]="disabled"
          [successful]="successful"
        ></app-text-field>
      </div>
    </div>
  </div>

  <div class="playground__section">
    <h3 class="playground__section-title">Estado error (validadores)</h3>
    <p class="playground__section-hint">
      Email vacío o inválido: toca el campo y sal, o pulsa el botón para marcar touched.
      Los mensajes se personalizan con <code>[errorMessages]</code>.
    </p>
    <div class="playground__preview-box playground__preview-box--narrow">
      <app-text-field
        [control]="emailControl"
        appearance="outlined"
        label="Email"
        placeholder="correo@ejemplo.com"
        hint="Debe ser un email válido"
        [errorMessages]="emailErrorMessages"
      ></app-text-field>
      <button type="button" class="playground__btn" (click)="markEmailTouched()">Marcar touched (mostrar error)</button>
    </div>
  </div>
</section>
